import React from "react";
import { Card } from "../common/Card";
import alertIcon from "../../images/alert.svg";
import { Button } from "../common/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function RedirectPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleReturnToMainPage = () => {
        navigate("/")
    };

    return (
        <Card centerContext={true}>
            <div className="flex flex-col items-center text-center">
                <img src={alertIcon} alt="" />
                <h1
                    className="font-extrabold text-xl sm:text-2xl md:text-3xl leading-tight mb-5 mt-5 font-sans">{t("redirect-page.title")}
                </h1>
                <div className="flex flex-col mt-5 mb-5 items-center w-md-75">
                    <p className="text-base sm:text-lg md:text-xl leading-tight font-sans">{t("redirect-page.description-first")}</p>
                    <p className="text-base sm:text-lg md:text-xl leading-tight font-sans">{t("redirect-page.description-second")}</p>
                </div>

                <Button className="mt-5" text={t("common.button-return")} onClick={handleReturnToMainPage} />
            </div>
        </Card>
    )
}
